// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"234":"55233685","832":"c5ebc922","922":"7b368872"}[chunkId] + ".css";
};